import L from 'leaflet';
import './mapMarkerIcons.css';

export function mapPriceLabel(amount) {
  if(amount == null || amount === '' || !Number.isFinite(Number(amount))) return 'Home';
  return new Intl.NumberFormat('en-US',{style:'currency',currency:'USD',notation:'compact',maximumFractionDigits:1}).format(Number(amount));
}

const houseDrawing='<svg class="property-map-house" viewBox="0 0 40 36" aria-hidden="true"><path d="M8 16h25v16H8z" fill="#fff4d6" stroke="#65475c" stroke-width="1.6" stroke-linejoin="round"/><path d="M28 8V3h5v10" fill="#d88968" stroke="#65475c" stroke-width="1.6"/><path d="M3 17L20 3l17 14" fill="#df9978" stroke="#65475c" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/><path d="M4 18L20 5l16 13" fill="none" stroke="#fff7e7" stroke-width="1.5" stroke-linecap="round"/><path d="M18 22h7v10h-7z" fill="#9f795e"/><rect x="11" y="21" width="5" height="5" rx="1" fill="#72bdc2" stroke="#65475c" stroke-width="1"/><path d="M9 33h24" stroke="#fffaf0" stroke-width="2.5" stroke-linecap="round"/></svg>';

export function propertyMapIcon(amount,{isPrivate=false}={}) {
  const label=mapPriceLabel(amount);
  return L.divIcon({
    html:`<div class="property-map-art">${houseDrawing}<span class="property-map-price">${label}</span><span class="property-map-tip" aria-hidden="true"></span></div>`,
    className:`property-map-marker${isPrivate?' property-map-marker--private':''}`,
    iconSize:[76,58],iconAnchor:[38,58],tooltipAnchor:[0,-52]
  });
}

export function clusterBubbleIcon(count) {
  const total=Math.max(0,Number(count) || 0),label=total.toLocaleString('en-US');
  const size=total<10?'small':total<100?'medium':'large';
  const diameter=Math.max(total<10?46:total<100?50:56,label.length*8+14);
  return L.divIcon({
    html:`<div class="map-cluster-art"><svg viewBox="0 0 20 15" aria-hidden="true"><path d="M2 7L10 1l8 6M5 6v7h10V6M9 13V9h3v4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg><span>${label}</span></div>`,
    className:`marker-cluster marker-cluster-${size} bounded-map-cluster illustrated-map-cluster`,
    iconSize:L.point(diameter,diameter),iconAnchor:[diameter/2,diameter/2]
  });
}
